import '../styles/_components/PhotoRow.scss';

type ContentBlockProps = {
	className?: string;
	imageId: string;
};

function PhotoRowBackground({ className = '', imageId }: ContentBlockProps) {
	return (
		<div className={`photorow photorow--bg ${className}`} id={imageId}>
			<div className="container container--wide photorow__container">
				<div className="photorow__columns">
					<div className="photorow__column photorow__column--left">
						<div className="photorow__overlay">
							<div className="logofocus">
								<a href="https://sunore.be/" target="_blank" rel="noreferrer">
									<img className={`logofocus__image`} src={`/images/logosunore.png`} alt="Logo Sunero - where dogs thrive" />
								</a>
								<span>
									Sunoré, waar honden <em>thriven</em>. Unieke krachtige supplementen op maat voor jouw hond.
									<br />
									<br />
									<a href="https://sunore.be/" target="_blank" rel="noreferrer">
										sunore.be
									</a>
								</span>
							</div>
						</div>
					</div>
					<div className="photorow__column photorow__column--wide photorow__column--right">
						<div className="photorow__overlay">
							<h3 className="sronly">Gezonde recepten</h3>
							<p>Download hier gratis gezonde recepten voor uw hond!</p>
							<a target="_blank" rel="noreferrer" href={`${process.env.PUBLIC_URL}/recept/receptbataatcottagecheese.pdf`} className="button button--secondary">
								Bataat – Cottage Cheese Snack
							</a>
							<a target="_blank" rel="noreferrer" href={`${process.env.PUBLIC_URL}/recept/receptbottenbouillon.pdf`} className="button button--secondary">
								Bottenbouillon
							</a>
							<a target="_blank" rel="noreferrer" href={`${process.env.PUBLIC_URL}/recept/receptdrmorowortelsoep.pdf`} className="button button--secondary">
								Dr. Moro's Wortelsoep
							</a>
							<a target="_blank" rel="noreferrer" href={`${process.env.PUBLIC_URL}/recept/receptgedroogdfruitengroenten.pdf`} className="button button--secondary">
								Gedroogd Fruit en Groente Snacks
							</a>
							<a target="_blank" rel="noreferrer" href={`${process.env.PUBLIC_URL}/recept/receptgezondejellysvoorhonden.pdf`} className="button button--secondary">
								Gezonde Jelly's
							</a>
							<a target="_blank" rel="noreferrer" href={`${process.env.PUBLIC_URL}/recept/recepthavermoutkoekjes.pdf`} className="button button--secondary">
								Wortel-Havermout Koekjes
							</a>
							<a target="_blank" rel="noreferrer" href={`${process.env.PUBLIC_URL}/recept/receptpompoenmeteimuffins.pdf`} className="button button--secondary">
								Pompoen Muffins met ei
							</a>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}

export default PhotoRowBackground;
